export default __webpack_public_path__ + "media/images/Masto-G1-Fediverse-a31c0024c7fad1d0a0c1761aea52c009.png";